
import React from "react";
export const Context = React.createContext();

export const title = 'eCommerce and Digital Transformation Specialists';
export const description = "We love to solve problems and offer you valuable insights into new ideas around development, support, automation and integration."
export const thumbnail = "https://apprato.com.au/images/Apprato_Logo_white.png"

export const blogTitle = 'Apprato Insights';
export const blogDescription = 'The Apprato insights is the hub for developers, business owners, managers and entrepreneurs featuring key technology, news, resources and insights that help run smarter eCommerce businesses.';